<template>

  <div>

    <div class="item-print k80-invoice">

      <div class="heading heading--invoice">
         <img
          src="/media/logos/clickbuy.png"
          alt="Clickbuy"
          class="heading-logo"
        />
        <p class="bill-content">{{ bill.storeAddress }}</p>

        <p class="bill-content">
           <span class="header-inline-label">ID</span> {{ bill.billNumber }}
        </p>

        <p class="bill-content">
           <span class="header-inline-label">Ngày giờ</span> {{ bill.createdAt }}
        </p>

        <h5 class="text-bold text-center invoice-title">HÓA ĐƠN BÁN HÀNG</h5>

      </div>

      <div class="customer font-size-print text-500">

        <div class="customer-line">
           <span class="text-title">Khách hàng</span> <span class="customer-value">{{
            bill.customerName
          }}</span
          >
        </div>

        <div class="customer-line">
           <span class="text-title">Điện thoại</span> <span class="customer-value">{{
            bill.customerPhone
          }}</span
          >
        </div>

        <div class="customer-line customer-line--addr">
           <span class="text-title">Địa chỉ</span> <span class="customer-value customer-addr">{{
            bill.customerAddress
          }}</span
          >
        </div>

        <div class="customer-line">
           <span class="text-title">Ghi chú</span> <span class="customer-value">{{
            bill.orderNote || ''
          }}</span
          >
        </div>

      </div>

      <div class="product-section">

        <table class="product-table">

          <thead>

            <tr>

              <th class="text-center col-p">
                 <span class="text-bold-600 font-size-print">Đơn giá</span>
              </th>

              <th class="text-center col-sl">
                 <span class="text-bold-600 font-size-print">Số lượng</span>
              </th>

              <th class="text-center col-d">
                 <span class="text-bold-600 font-size-print">Chiết khấu</span>
              </th>

              <th class="text-right col-t">
                 <span class="text-bold-600 font-size-print">Thành tiền</span>
              </th>

            </tr>

          </thead>

          <tbody
            v-for="(item, index) in bill.listBillItem"
            :key="'line-' + index"
          >

            <tr>

              <td
                colspan="4"
                class="cell-name"
              >
                 <span
                  v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS"
                  class="gift-emoji"
                  > 🎁 </span
                > <span class="bill-content font-size-print item-name">{{ item.name }}</span
                >
              </td>

            </tr>

            <tr v-if="item.imeiCode">

              <td
                colspan="4"
                class="cell-imei"
              >
                 <span class="font-size-print item-imei">IMEI: {{ item.imeiCode }}</span
                >
              </td>

            </tr>

            <tr class="row-values">

              <td class="text-center">
                 <span v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS">0</span> <span
                  v-else
                  class="bill-content font-size-print"
                  >{{ convertPrice(item.price) }}</span
                >
              </td>

              <td class="text-center">
                 <span class="bill-content font-size-print">{{ item.quantity }}</span
                >
              </td>

              <td class="text-center">
                 <span v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS">0</span> <span
                  v-else
                  class="bill-content font-size-print"
                  >{{ convertPrice(item.discountAmountValue) }}</span
                >
              </td>

              <td class="text-right">
                 <span v-if="item.billItemType === BILL_ITEM_TYPE.PRODUCT_BONUS">0</span> <span
                  v-else
                  class="bill-content font-size-print"
                  >{{ convertPrice(item.totalPrice) }}</span
                >
              </td>

            </tr>

          </tbody>

        </table>

        <div
          v-if="promotionProgramsList.length"
          class="promo-block font-size-print"
        >

          <p class="promo-title">Chương trình áp dụng:</p>

          <ul class="promo-list">

            <li
              v-for="(name, idx) in promotionProgramsList"
              :key="'p-' + idx"
            >
               * {{ name }}
            </li>

          </ul>

        </div>

        <table class="summary-table">

          <tbody>

            <tr>

              <td class="sum-label">Số lượng:</td>

              <td class="sum-val">{{ bill.sumQuantity }}</td>

            </tr>

            <tr>

              <td class="sum-label">Tổng tiền:</td>

              <td class="sum-val">{{ convertPrice(bill.sumUnitAmount) }}</td>

            </tr>

            <tr>

              <td class="sum-label">Tổng chiết khấu:</td>

              <td class="sum-val">{{ convertPrice(bill.sumTotalDiscount) }}</td>

            </tr>

            <tr>

              <td class="sum-label">Tiền đã cọc:</td>

              <td class="sum-val">{{ convertPrice(bill.depositAmount) }}</td>

            </tr>

            <tr>

              <td class="sum-label">Tiêu điểm:</td>

              <td class="sum-val">{{ convertPrice(bill.pointUse) }}</td>

            </tr>

            <tr>

              <td class="sum-label">Phí ship:</td>

              <td class="sum-val">{{ convertPrice(shipFeeDisplay) }}</td>

            </tr>

            <tr v-if="bill.conversionFee">

              <td class="sum-label">Phí chuyển đổi:</td>

              <td class="sum-val">{{ convertPrice(bill.conversionFee) }}</td>

            </tr>

            <tr class="row-grand-total">

              <td class="sum-label">TỔNG TIỀN THANH TOÁN:</td>

              <td class="sum-val">{{ convertPrice(bill.totalPay) }}</td>

            </tr>

            <tr class="row-amount-words">

              <td colspan="2">
                 <span class="amount-words">Bằng chữ: {{ bill.textAmount }}</span
                >
              </td>

            </tr>

          </tbody>

        </table>

      </div>

      <hr class="hr-dash" />

      <div class="footer-staff font-size-print text-500">

        <div class="footer-kv">
           <span>Tư vấn bán hàng</span> <span>{{ bill.saleName || '' }}</span
          >
        </div>

        <div class="footer-kv">
           <span>Thu ngân</span> <span>{{ bill.cashierName || '' }}</span
          >
        </div>

      </div>

      <hr class="hr-dash hr-mid" />

      <div class="footer-contact font-size-print">

        <div class="footer-kv"> <span>Hotline BH</span> <span>1900 633 909 (nhánh 3)</span> </div>

        <div class="footer-kv"> <span>Khiếu nại</span> <span>0918 000 731</span> </div>

      </div>

      <p class="thank-you">
         Cảm ơn quý khách đã tin tưởng lựa chọn sản phẩm và dịch vụ của chúng tôi!
      </p>

    </div>

  </div>

</template>

<script>
  import { convertPrice } from '@/utils/common'
  import { BILL_ITEM_TYPE } from '@/utils/enum'

  export default {
    props: ['bill', 'productUsages'],
    data() {
      return {
        BILL_ITEM_TYPE,
      }
    },
    methods: {
      convertPrice,
    },
    created() {},
    computed: {
      getPhoneNumberByStoreType() {
        return this.bill.storeHotline ? this.bill.storeHotline : '1900.633.909'
      },
      shipFeeDisplay() {
        const b = this.bill || {}
        if (b.shipFee != null && b.shipFee !== '') {
          return b.shipFee
        }
        return b.customerShipFee || 0
      },
      promotionProgramsList() {
        const b = this.bill || {}
        if (Array.isArray(b.promotionPrograms) && b.promotionPrograms.length) {
          return b.promotionPrograms.filter(Boolean)
        }
        if (typeof b.promotionPrograms === 'string' && b.promotionPrograms.trim()) {
          return [b.promotionPrograms.trim()]
        }
        if (Array.isArray(b.promotionProgramNames) && b.promotionProgramNames.length) {
          return b.promotionProgramNames.filter(Boolean)
        }
        return []
      },
    },
  }
</script>

<style lang="css" scoped>
  /* ================ Common ================ */
.tab {
  position: absolute;
  left: 10em;
}

body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.k80-invoice {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 6px 0 8px;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.25;
}

.customer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}

.customer .text-title {
  min-width: 80px;
  display: inline-block;
  position: relative;
}

.customer .text-title::after {
  content: ':';
  position: absolute;
  right: -4px;
}

.text-bold-600 {
  font-weight: 600;
}

.list-product {
  display: contents;
}
.heading-logo {
  width: 170px;
  max-width: 68%;
  object-fit: contain;
  margin: 0 auto 4px;
  display: block;
}
.bill-content {
  font-weight: 500;
  line-height: 1.35;
  color: #000000;
  margin-bottom: 0;
}
tr th {
  color: #000000;
  font-weight: 500;
}

tr td {
  color: #000000;
  font-weight: 500;
}

.heading {
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
}

.k80-invoice .heading--invoice {
  margin-bottom: 8px;
  font-size: 13px;
}

.k80-invoice .header-inline-label {
  margin-right: 4px;
}

.k80-invoice .header-inline-label::after {
  content: ':';
}

.k80-invoice .invoice-title {
  font-size: 16px;
  margin: 6px 0 0;
}

.k80-invoice .customer {
  gap: 0.2rem;
  width: 100%;
  margin: 0 0 8px;
}

.k80-invoice .customer-line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
}

.k80-invoice .customer-line--addr {
  align-items: flex-start;
}

.k80-invoice .customer .text-title {
  min-width: 56px;
}

.k80-invoice .customer-value {
  flex: 1;
  text-align: right;
  word-break: break-word;
}

.k80-invoice .customer-addr {
  line-height: 1.35;
  white-space: normal;
}

.loyalty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0;
  gap: 1rem;
}

.loyalty .text-title {
  min-width: 160px;
  display: inline-block;
  position: relative;
}

.loyalty .text-title::after {
  content: ':';
  position: absolute;
  right: 0;
}

hr {
  border: none;
  border-top: 2px dotted black;
  color: #fff;
  background-color: #fff;
  height: 2px;
}
hr.dotted {
  border: none;
  border-top: 1px dotted cadetblue;
  color: #fff;
  background-color: #fff;
  height: 1px;
}

.product-table {
  margin: 6px 0 4px;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.product-table thead tr {
  border-top: 1px dashed black;
  border-bottom: 1px dashed black;
  line-height: 18px;
}

.product-table thead th {
  font-style: italic;
  font-weight: 400;
}

.product-table tfoot {
  border-top: 1px dashed black;
  border-bottom: 1px dashed black;
  line-height: 24px;
}

.product-table tbody tr {
  line-height: 16px;
}

.k80-invoice .col-p {
  width: 25%;
}

.k80-invoice .col-sl {
  width: 14%;
}

.k80-invoice .col-d {
  width: 17%;
}

.k80-invoice .col-t {
  width: 44%;
}

.k80-invoice .cell-name {
  padding: 6px 2px 0;
}

.k80-invoice .cell-imei {
  padding: 0 2px 2px;
}

.k80-invoice .item-name {
  font-weight: 700;
}

.k80-invoice .item-imei {
  font-style: italic;
}

.k80-invoice .gift-emoji {
  margin-right: 4px;
}

.k80-invoice .row-values td {
  border-bottom: 0.5px dashed black;
  padding: 0 1px 3px;
}

.k80-invoice .promo-block {
  width: 100%;
  margin: 6px 0 4px;
}

.k80-invoice .promo-title {
  margin: 0 0 4px;
  font-style: italic;
}

.k80-invoice .promo-list {
  margin: 0;
  padding-left: 0;
  list-style: none;
  font-style: italic;
}

.k80-invoice .promo-list li {
  line-height: 1.3;
}

.k80-invoice .summary-table {
  width: 100%;
  margin-left: 0;
  border-collapse: collapse;
}

.k80-invoice .sum-label {
  text-align: left;
  width: 46%;
  padding: 2px 2px 2px 0;
}

.k80-invoice .sum-val {
  text-align: right;
  padding: 2px 0;
}

.k80-invoice .row-grand-total .sum-label,
.k80-invoice .row-grand-total .sum-val {
  font-weight: 700;
  font-size: 14px;
  padding-top: 8px;
}

.k80-invoice .row-amount-words td {
  padding-top: 2px;
}

.k80-invoice .amount-words {
  font-style: italic;
  font-size: 13px !important;
}

.k80-invoice .hr-dash {
  border: none;
  border-top: 1px dashed #000;
  width: 100%;
  margin: 8px 0;
  height: 0;
}

.k80-invoice .hr-mid {
  margin: 10px 0 8px;
}

.k80-invoice .footer-kv {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 2px;
}

.k80-invoice .footer-kv span:last-child {
  text-align: right;
}

.k80-invoice .thank-you {
  text-align: center;
  width: 100%;
  font-size: 13px !important;
  padding: 8px;
  line-height: 1.35;
}

.list-product tr:last-child {
  border-bottom: 1px dashed black;
}

.text-bold {
  color: black;
  font-weight: 600;
}

.text-500 {
  color: black;
  font-weight: 500;
}

.text-align-center {
  text-align: center;
}

.text-styles {
  color: black;
  font-size: 15px;
}
.content-info {
  color: black;
  font-weight: 450;
}
.font-size-print {
  font-size: 14px !important;
}
.content-product {
  line-height: 1.375;
  white-space: pre-wrap;
  font-size: 15px;
  margin-top: 4px;
}
.item-print {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.text-download-app {
  color: black;
  font-weight: 500;
  margin-top: 4px;
  line-height: 1.3;
}
</style>

<style lang="css">
  @page {
  size: 97mm 297mm;
  margin: 0;
}

@media print {
  html,
  body {
    width: 97mm !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .item-print,
  .k80-invoice {
    width: 97mm !important;
    min-width: 97mm !important;
    max-width: 97mm !important;
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>

